module.exports = __webpack_public_path__ + "static/request-img-placeholder4-376249f2455b9fbe6a90716928c3956e.jpg";